import React, { useState, useRef, useEffect } from "react";
import InputFactory from "../../../../components/InputFactory";
import ProgressDialog from "../../../../components/common/ProgressDialog";
import { convertFlatStringFactory, formatValueForPrint } from "../helper-payroll/HelperFunction";
import FormFactory from "../../../../components/FormFactory";
import {
  formatCurrency,
  formatNumber,
} from "../../../../components/common/Converter";
// import "./TablePayroll.css";
import tableStyles from "./TablePayrollStyle";
import {
  shouldRenderInput,
  getValueOrDefault,
  shouldRenderDaterange,
  shouldBeFormatted,
  shouldRenderMultipleInputs,
  shouldFormatArray,
} from "./render-conditions/PayrollRenderingRules";
import { getDefaultOfDuty } from "../helper-payroll/HelperFunction";
import { isAddendumBackPayItem } from "../helper-payroll/constants/payrollConstants";

const TablePayroll = (props) => {
  const {
    tableHeader = [],
    primarySubHdr = [],
    secondarySubHdr = [],
    object = [],
    tfootObjects = {},
    headersKey = [],
    value = [],
    onChange = () => {},
    onclickAction = () => {},
    schema = {},
    selectedTypes = {},
    isLoading = false,
    isColumShow = false,
    styles = {},
    isValueOnly = false,
    isActive = true,
    sortByLastname = false,
    startIndex = 0,
    loadingProgress = 0,
    processedCount = 0,
    totalCount = 0,
  } = props;

  const headerRow1Ref = useRef(null);
  const headerRow2Ref = useRef(null);
  const [headerTopOffsets, setHeaderTopOffsets] = useState({
    row1: 0,
    row2: 0,
    row3: 0,
  });
  
  const isBpGeneral =
    selectedTypes?.payrollTypes === "BP" &&
    selectedTypes?.jobTypeVal !== "Job Order" &&
    selectedTypes?.payItems === "General Payroll";
  const isBpAddendum =
    selectedTypes?.payrollTypes === "BP" &&
    selectedTypes?.jobTypeVal !== "Job Order" &&
    (selectedTypes?.payItems === "Addendum Payroll" ||
      isAddendumBackPayItem(selectedTypes?.payItems));

  const getNetValue = (item) => {
    const raw = item["netPay"] ?? item["netAmount"];
    if (raw == null || raw === "") return NaN;
    if (typeof raw === "number") return raw;
    const cleaned = String(raw).replace(/,/g, "").replace(/[^\d.-]/g, "");
    return parseFloat(cleaned);
  };

  const shouldHighlightRow = (netValue) => {
    if (isNaN(netValue)) return false;
    if (isBpGeneral) return netValue < 5000;
    if (isBpAddendum) return netValue < 0;
    return netValue < 0;
  };

  const sortedObject = object
    .map((item, originalIndex) => ({
      ...item,
      originalIndex,
    }))
    .sort((a, b) => {
      const normalizeName = (value) =>
        value == null ? "" : String(value).trim();
      const compareByName = (x, y) => {
        const xLn = normalizeName(x.ln);
        const yLn = normalizeName(y.ln);
        const xFn = normalizeName(x.fn);
        const yFn = normalizeName(y.fn);
        const xMn = normalizeName(x.mn);
        const yMn = normalizeName(y.mn);

        const lnCompare = xLn.localeCompare(yLn, undefined, {
          sensitivity: "base",
        });
        if (lnCompare !== 0) return lnCompare;

        const fnCompare = xFn.localeCompare(yFn, undefined, {
          sensitivity: "base",
        });
        if (fnCompare !== 0) return fnCompare;

        const mnCompare = xMn.localeCompare(yMn, undefined, {
          sensitivity: "base",
        });
        if (mnCompare !== 0) return mnCompare;

        return x.originalIndex - y.originalIndex;
      };

      const getPriorityRank = (item) => {
        const netValue = getNetValue(item);
        if (isNaN(netValue)) return 2;
        if (isBpGeneral) {
          if (netValue < 0) return 0;
          if (netValue < 5000) return 1;
          return 2;
        }
        if (netValue < 0) return 0;
        return 2;
      };

      // if (sortByLastname) {
      //   return a.ln.localeCompare(b.ln, undefined, { sensitivity: "base" });
      // }

      if (sortByLastname) {
        return compareByName(a, b);
      }

      const priorityDiff = getPriorityRank(a) - getPriorityRank(b);
      if (priorityDiff !== 0) return priorityDiff;
      return compareByName(a, b);
    });

  const isZeroFieldLabel = new Set([
    "overpaymentBasic",
    "overpaymentPeraAda",
    "overpayment",
    "flagRaising",
    "3",
    "2",
    "5",
    "10",
  ]);
  const isJoSalary =
    selectedTypes?.jobTypeVal === "Job Order" &&
    selectedTypes?.payItems === "Salary";

  const excludedLabels = [
    "OfDutyForCiaMciaBinocRangeTo1519",
    "OfDutyForCiaMciaBinocRangeTo15192",
    "dateOfAbsencesLeave",
    "gsisInsuredDays",
    "noOfDuties",
    "y247N700530",
    "dateOfAbsences",
    "datesOfAbsence",
    "datesOfHalfDay",
    "leaveWithoutPayDates",
    "datesOfFlagRaising",
    "dateOfHalfDays",
    ...(isJoSalary ? [] : ["daysToBeDeducted"]),
    "halfDaysToBeDeducted",
    "minutesToBeDeducted",
  ];
  const filteredHeadersKey = isColumShow
    ? [
        { label: "" },
        ...headersKey.filter(({ label }) => {
          if (!label || excludedLabels.includes(label)) {
            return false;
          }

          return object.some((item) => {
            const value = item[label];

            const isZeroArray =
              Array.isArray(value) && value.every((v) => v === 0);
            const isZeroField =
              isZeroFieldLabel.has(label) && (value === 0 || value === "0");

            return (
              value != null && value !== "" && !isZeroArray && !isZeroField
            );
          });
        }),
      ]
    : headersKey;

  // console.log("headersKey", headersKey);

  const groupMap = {};
  let currentIndex = 0;

  for (const header of tableHeader) {
    if (header.colSpan) {
      groupMap[header.label] = primarySubHdr.slice(
        currentIndex,
        currentIndex + header.colSpan
      );
      currentIndex += header.colSpan;
    }
  }

  const convertFlatString_1 = convertFlatStringFactory();

  const formatValueForPrint = (
    value,
    shouldFormatCurrency = false,
    emptyForZero = false
  ) => {
    const useEmptyDisplay = isValueOnly || emptyForZero;

    if (value === undefined || value === null || value === "") {
      return useEmptyDisplay ? "" : value ?? "";
    }

    const isZeroValue =
      value === 0 ||
      value === "0" ||
      value === "0.00" ||
      value === "0.0" ||
      (!isNaN(parseFloat(value)) && parseFloat(value) === 0);

    if (isZeroValue && useEmptyDisplay) {
      return "";
    }

    return shouldFormatCurrency ? formatCurrency(value.toString()) : value;
  };

  const isNumericValue = (value) => {
    if (value == null || value === "") return false;
    if (typeof value === "number") return !isNaN(value);
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed === "-" || trimmed === "") return false;
      const numValue = parseFloat(trimmed.replace(/[^0-9.-]/g, ""));
      return !isNaN(numValue) && isFinite(numValue);
    }
    return false;
  };

  const getCellAlignment = (value, keyLabel) => {
    if (!isValueOnly) return {};
    
    if (keyLabel?.trim() === "") return { textAlign: "left" };
    
    const leftAlignLabels = ["acctNo", "accountNumber", "employeeNumber", "daysInAMonth", "gsisInsuredDays", "noOfDays", "OfDutyForCiaMciaBinocRangeTo1519", "abs", "latesUt", "noOfDuties", "abs2", "latesUt2", "year"];
    const rightAlignLabels = [];
    
    if (leftAlignLabels.includes(keyLabel)) {
      return { textAlign: "left" };
    }
    
    if (rightAlignLabels.includes(keyLabel)) {
      return { textAlign: "right" };
    }
    
    if (Array.isArray(value)) {
      const firstVal = value[0];
      return isNumericValue(firstVal) 
        ? { textAlign: "right" } 
        : { textAlign: "left" };
    }
    
    return isNumericValue(value) 
      ? { textAlign: "right" } 
      : { textAlign: "left" };
  };

  const getFilteredGroupCount = (groupLabels) => {
    return groupLabels.filter((label) => {
      const toCamelCase = convertFlatString_1(label);

      return filteredHeadersKey.some((f) => f.label === toCamelCase);
    }).length;
  };

  const convertFlatString_2 = convertFlatStringFactory();

  const updatedTableHeader = isColumShow
    ? tableHeader
        .map((header) => {
          if (header.colSpan && groupMap[header.label]) {
            const count = getFilteredGroupCount(groupMap[header.label]);
            return count > 0 ? { ...header, colSpan: count } : null;
          }

          const toCamelCase = convertFlatString_2(header.label);
          const labelMatch = filteredHeadersKey.some(
            (f) => f.label === toCamelCase
          );
          return header.rowSpan || labelMatch ? header : null;
        })
        .filter(Boolean)
    : tableHeader;

  const convertFlatString_3 = convertFlatStringFactory();

  const filteredPrimarySubHdr = isColumShow
    ? primarySubHdr.filter((item) => {
        const convertedLabels = convertFlatString_3(item);
        return filteredHeadersKey.find((key) => key.label === convertedLabels);
      })
    : primarySubHdr;

  let primarySubhdrIndex = 0;

  const convertFlatString_4 = convertFlatStringFactory();
  // const convertFlatString_5 = convertFlatStringFactory();
  const filteredTableHeader = isColumShow
    ? updatedTableHeader
        .map((item) => {
          const camelLabel = convertFlatString_4(item.label);

          if (item.colSpan) {
            const originalSubHeaders = filteredPrimarySubHdr.slice(
              primarySubhdrIndex,
              primarySubhdrIndex + item.colSpan
            );

            primarySubhdrIndex += item.colSpan;

            if (originalSubHeaders.length === 0) return null;

            return {
              ...item,
              colSpan: originalSubHeaders.length,
            };
          }

          const hasData = filteredHeadersKey.some(
            (key) => key.label === camelLabel
          );
          return hasData ? item : null;
        })
        .filter(Boolean)
    : tableHeader;

  const convertFlatString_5 = convertFlatStringFactory();
  const filteredSecondarySubHdr = isColumShow
    ? secondarySubHdr.filter((item) => {
        const convertedItem = convertFlatString_5(item);

        return filteredHeadersKey.find((key) => key.label === convertedItem);
      })
    : secondarySubHdr;

  const hasColSpan = tableHeader.some((header) => "colSpan" in header);
  const headerCount = tableHeader.reduce(
    (count, header) => {
      return count + (header.colSpan || 0);
    },
    hasColSpan ? tableHeader.length - 1 : tableHeader.length
  );

  useEffect(() => {
    const calculateOffsets = () => {
      if (headerRow1Ref.current && headerRow2Ref.current) {
        const row1Height = headerRow1Ref.current.offsetHeight;
        const row2Height = headerRow2Ref.current.offsetHeight;
        setHeaderTopOffsets({
          row1: 0,
          row2: row1Height,
          row3: row1Height + row2Height,
        });
      }
    };

    const timeoutId = setTimeout(calculateOffsets, 0);
    window.addEventListener("resize", calculateOffsets);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", calculateOffsets);
    };
  }, [filteredTableHeader, filteredPrimarySubHdr, filteredSecondarySubHdr, isLoading]);

  return (
    <>
      <style>{`
    .custom-scrollbar::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: rgb(241, 241, 241);
    }
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background-color: rgb(173, 206, 237);
      border-radius: 4px;
    }
    .custom-scrollbar::-webkit-scrollbar-track {
      background-color: rgb(241, 241, 241);
    }
    .payroll-table > :not(:first-child) {
      border-top: 0 !important;
    }
  `}</style>
      <div
        className="custom-scrollbar"
        style={{
          ...tableStyles.scrollContainer,
          ...(styles?.scrollContainer || {}),
        }}
      >
        <table
          className={isColumShow ? "payroll-table" : "table table-hover payroll-table"}
          style={{ ...tableStyles.table, ...(styles?.table || {}) }}
        >
          <thead
            className={isActive ? "table-active" : ""}
            style={{ ...tableStyles.active, ...(styles?.active || {}) }}
          >
            <tr
              ref={headerRow1Ref}
              className={isActive ? "table-active" : ""}
              style={{ 
                ...tableStyles.active, 
                ...(styles?.active || {})
              }}
            >
              {filteredTableHeader.map((item, index) => (
                <th
                  style={
                    item.label === "PERIOD COVERED"
                      ? {
                          ...tableStyles.dateHdrCell,
                          top: headerTopOffsets.row1,
                          ...(styles?.dateHdrCell || {}),
                        }
                      : {
                          ...tableStyles.headerCell,
                          top: headerTopOffsets.row1,
                          ...(styles?.headerCell || {}),
                        }
                  }
                  key={index}
                  colSpan={item.colSpan}
                  rowSpan={item.rowSpan}
                >
                  {item.displayLabel || item.label}
                </th>
              ))}
            </tr>
            <tr
              ref={headerRow2Ref}
            >
              {filteredPrimarySubHdr.map((header, index) => (
                <th
                  style={
                    header === "DATE"
                      ? {
                          ...tableStyles.dateHdrCell,
                          top: headerTopOffsets.row2,
                          ...(styles?.dateHdrCell || {}),
                        }
                      : {
                          ...tableStyles.headerCell,
                          top: headerTopOffsets.row2,
                          ...(styles?.headerCell || {}),
                        }
                  }
                  key={index}
                  colSpan={
                    typeof header === "object" && header.colSpan
                      ? header.colSpan
                      : 1
                  }
                  rowSpan={
                    typeof header === "object" && header.rowSpan
                      ? header.rowSpan
                      : 1
                  }
                >
                  {typeof header === "object"
                    ? header.displayLabel || header.label
                    : header}
                </th>
              ))}
            </tr>
            <tr>
              {filteredSecondarySubHdr.map((label, index) => (
                <th
                  style={{
                    ...tableStyles.headerCell,
                    top: headerTopOffsets.row3,
                    ...(styles?.headerCell || {}),
                  }}
                  key={index}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={headerCount}>
                  <div
                    style={{
                      ...tableStyles.spinContainer,
                      ...(styles?.spinContainer || {}),
                    }}
                  >
                    <ProgressDialog
                      saveProgress={loadingProgress}
                      savedCount={processedCount}
                      totalCount={totalCount}
                      showDetails={false}
                      title="Processing payroll records...."
                    />
                  </div>
                </td>
              </tr>
            ) : sortedObject.length > 0 ? (
              sortedObject.map((item, index) => {
                const originalIndex = item.originalIndex;

                const netValue = getNetValue(item);

                const rowStyle = shouldHighlightRow(netValue)
                  ? { backgroundColor: "#ffebeb" }
                  : {};
                return (
                  <tr
                    key={item.id ?? `row-${originalIndex}`}
                    style={{
                      ...tableStyles.tr,
                      ...(styles?.tr || {}),
                    }}
                  >
                    {/* <td>{index}</td> */}
                    {filteredHeadersKey.map((key, idx) => {
                      const cellValue = item[key.label];
                      const alignmentStyle = getCellAlignment(cellValue, key.label);
                      
                      return (
                      <td
                        style={{
                          ...tableStyles.td,
                          ...(styles?.td || {}),
                          ...rowStyle,
                          ...alignmentStyle,
                        }}
                        key={idx}
                      >
                        {shouldRenderInput(key.label, selectedTypes, item) ? (
                          isValueOnly ? (
                            Array.isArray(item[key.label]) ? (
                              <div
                                style={{
                                  ...tableStyles.inputContainer,
                                  ...(styles?.inputContainer || {}),
                                }}
                              >
                                {item[key.label].map((val, i) => (
                                  <span key={i}>
                                    {shouldFormatArray(key.label, val)
                                      ? formatValueForPrint(val ?? 0, true)
                                      : formatValueForPrint(val, false)}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              formatValueForPrint(
                                getValueOrDefault(
                                  value?.[originalIndex]?.[key.label],
                                  key.label,
                                  item
                                ),
                                false
                              )
                            )
                          ) : (
                            <InputFactory
                              type="String"
                              value={formatNumber(
                                getValueOrDefault(
                                  value?.[originalIndex]?.[key.label],
                                  key.label,
                                  item
                                ))}
                              onChange={(val) => {
                                const cleaned = val.replace(/,/g, "");

                                // if (cleaned === "") {
                                //   console.log("cleaned is empty");
                                //   onChange("", originalIndex, key.label, item["id"]);
                                //   return;
                                // }

                                onChange(cleaned, originalIndex, key.label, item["id"]);
                              }}
                              onBlur={(e) => {
                                const cleaned = e.target.value.replace(/,/g, "");
                                
                                if (cleaned === "") {
                                  onChange(
                                    0,
                                    originalIndex,
                                    key.label,
                                    item["id"]
                                  );
                                  return;
                                }

                                const numericValue = parseFloat(cleaned);

                                onChange(
                                  isNaN(numericValue) ? "" : numericValue,
                                  originalIndex,
                                  key.label,
                                  item["id"]
                                );
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.target.blur();
                                }
                              }}
                            />
                          )
                        ) : shouldRenderDaterange(key.label, selectedTypes) ? (
                          <FormFactory
                            schema={schema}
                            onChange={(value) =>
                              onChange(value, index, key.label, item["id"])
                            }
                            required={false}
                            excludeFields={
                              schema?.fields
                                ? Object.keys(schema.fields).filter(
                                    (key) => key !== "dateRange"
                                  )
                                : []
                            }
                            onclickAction={(value) =>
                              onclickAction(value, index, key.label)
                            }
                            allowClear={false}
                          />
                        ) : key.label?.trim() === "" ? (
                          startIndex + index + 1
                        ) 
                        // : key.label === "absencesMins" ? (
                        //   formatValueForPrint(item["absencesMins"] ?? 0, true)
                        // )
                         : shouldBeFormatted(key.label, item[key.label]) ? (
                          formatValueForPrint(item[key.label], true)
                        ) : Array.isArray(item[key.label]) ? (
                          shouldRenderMultipleInputs(
                            key.label,
                            selectedTypes
                          ) ? (
                            <div
                              style={{
                                ...tableStyles.inputContainer,
                                ...(styles?.inputContainer || {}),
                              }}
                            >
                              {item[key.label].map((val, i) =>
                                isValueOnly ? (
                                  <span key={i} style={tableStyles.spanArr}>
                                    {formatValueForPrint(
                                      value?.[index]?.[key.label]?.[i] ??
                                        (key.label === "noOfDays" ||
                                        key.label ===
                                          "OfDutyForCiaMciaBinocRangeTo1519"
                                          ? 22
                                          : key.label === "OfDutyForCiaMciaBinocRangeTo15192"
                                          ? getDefaultOfDuty(item)
                                          : key.label === "apRate"
                                          ? item["payCode"]
                                          : key.label === "basic"
                                          ? item["salary"]
                                          : key.label === "flagRaising"
                                          ? item["flagRaising"]?.[i]
                                          : key.label === "basicSalary"
                                          ? item["salary"]
                                          : ""),
                                      false
                                    )}
                                  </span>
                                ) : (
                                  <InputFactory
                                    key={i}
                                    type="String"
                                    value={formatNumber(
                                      value?.[index]?.[key.label]?.[i] ??
                                        (key.label === "noOfDays" ||
                                        key.label ===
                                          "OfDutyForCiaMciaBinocRangeTo1519"
                                          ? "22"
                                          : key.label === "OfDutyForCiaMciaBinocRangeTo15192"
                                          ? String(getDefaultOfDuty(item))
                                          : key.label === "apRate"
                                          ? item["payCode"]
                                          : key.label === "basic"
                                          ? item["salary"]
                                          : key.label === "flagRaising"
                                          ? item["flagRaising"]?.[i]
                                          : key.label === "basicSalary"
                                          ? item["salary"]
                                          : "")
                                    )}
                                    
                                    onChange={(inputVal) => {
                                      const cleaned = inputVal.replace(
                                        /,/g,
                                        ""
                                      );

                                      console.log("cleaned", cleaned);


                                      // if (isNaN(cleaned)) return;

                                      const numericValue = parseFloat(cleaned);

                                      const targetLength =
                                        item[key.label]?.length ?? 0;
                                      const currentArray =
                                        value?.[index]?.[key.label] ?? [];

                                      // Create a new array preserving existing values
                                      const updatedArray = Array.from(
                                        { length: targetLength },
                                        (_, idx) =>
                                          currentArray[idx] ??
                                          (key.label === "noOfDays" ||
                                          key.label ===
                                            "OfDutyForCiaMciaBinocRangeTo1519"
                                            ? "22"
                                            : key.label ===
                                              "OfDutyForCiaMciaBinocRangeTo15192"
                                            ? String(getDefaultOfDuty(item))
                                            : key.label === "apRate"
                                            ? item["payCode"]
                                            : key.label === "basic"
                                            ? item["salary"]
                                            : key.label === "flagRaising"
                                            ? item["flagRaising"]?.[idx]
                                            : key.label === "basicSalary"
                                            ? item["salary"]
                                            : "")
                                      );

                                      updatedArray[i] = cleaned; // store as number

                                      console.log("updatedArray", updatedArray);

                                      onChange(
                                        updatedArray,
                                        index,
                                        key.label,
                                        item["id"]
                                      );
                                    }}
                                    onBlur={(e) => {
                                      const cleaned = e.target.value.replace(
                                        /,/g,
                                        ""
                                      );
                                      const numericValue = parseFloat(cleaned);

                                      console.log("numericValue", numericValue);

                                      if (isNaN(numericValue)) return;

                                      const targetLength =
                                        item[key.label]?.length ?? 0;
                                      const currentArray =
                                        value?.[index]?.[key.label] ?? [];

                                      const updatedArray = Array.from(
                                        { length: targetLength },
                                        (_, idx) =>
                                          currentArray[idx] ??
                                          (key.label === "noOfDays" ||
                                          key.label ===
                                            "OfDutyForCiaMciaBinocRangeTo1519"
                                            ? "22"
                                            : key.label === "OfDutyForCiaMciaBinocRangeTo15192"
                                            ? String(getDefaultOfDuty(item))
                                            : key.label === "apRate"
                                            ? item["payCode"]
                                            : key.label === "basic"
                                            ? item["salary"]
                                            : key.label === "flagRaising"
                                            ? item["flagRaising"]?.[idx]
                                            : key.label === "basicSalary"
                                            ? item["salary"]
                                            : "")
                                      );

                                      updatedArray[i] = numericValue;
                                      onChange(
                                        updatedArray,
                                        index,
                                        key.label,
                                        item["id"]
                                      );
                                    }}
                                  />
                                )
                              )}
                            </div>
                          ) : (
                            <div
                              style={{
                                ...tableStyles.inputContainer,
                                ...(styles?.inputContainer || {}),
                              }}
                            >
                              {item[key.label].map((val, i) => (
                                <span key={i}>
                                  {shouldFormatArray(key.label, val)
                                    ? formatValueForPrint(val ?? 0, true)
                                    : formatValueForPrint(val, false)}
                                </span>
                              ))}
                            </div>
                          )
                        ) : (
                          formatValueForPrint(item[key.label], false)
                        )}
                      </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={headerCount}>
                  <div
                    style={{
                      ...tableStyles.imgContainer,
                      ...(styles?.imgContainer || {}),
                    }}
                  >
                    <img
                      style={{ ...tableStyles.img, ...(styles?.img || {}) }}
                      src={"/noData.svg"}
                      alt="No Data"
                    />
                  </div>
                  <p
                    style={{
                      ...tableStyles.noDataLbl,
                      ...(styles?.noDataLbl || {}),
                    }}
                  >
                    No Data
                  </p>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot style={{ ...tableStyles.tfoot, ...(styles?.tfoot || {}) }}>
            <tr>
              {filteredHeadersKey.map((key, index) => {
                const label = key.label;

                if (index === 0) {
                  return (
                    <td
                      style={{
                        ...tableStyles.tfootTabledata,
                        ...(styles?.tfootTabledata || {}),
                      }}
                      key={label}
                    >
                      Total
                    </td>
                  );
                }

                const value = tfootObjects[label];
                const footerAlignmentStyle = getCellAlignment(value, label);

                return (
                  <td
                    key={label}
                    style={{
                      ...tableStyles.tfootTabledata,
                      ...(styles?.tfootTabledata || {}),
                      ...footerAlignmentStyle,
                    }}
                  >
                    {formatValueForPrint(value, true, true)}
                  </td>
                );
              })}
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default TablePayroll;
